export interface Store {}

export enum ActionStatus {
  None,
  InProgress,
  Successful,
  Failed,
}
